import React, { useState, useEffect, useRef } from "react";
import HeaderAddApp from "./HeaderAddApp";
import AddNewApplication from "./AddNewApplication";
import CreateLicense from "./CreateLicense";
import CreateAddOn from "./CreateAddOn";
import { useLocation } from "react-router-dom";

const AddApplication = () => {
  const location = useLocation();
  const initialTab = location.state?.activeTab || "AddNewApplication";
  const [activeTab, setActiveTab] = useState(initialTab);
  const isTabLocked = location.state?.activeTab;
  const [applicationType, setApplicationType] = useState("");
  const containerRef = useRef(null);

  const handleTabClick = (tabName) => {
    if (applicationType?.trim().toLowerCase() === "enquiry") {
      console.log("Tab switching disabled for Enquiry type.");
      return;
    }

    if (!isTabLocked) {
      setActiveTab(tabName);
    }
  };

  useEffect(() => {
    console.log("applicationType changed:", applicationType);
  }, [applicationType]);

  const shouldShowTab = (tabName) => {
    if (!isTabLocked) return true;

    return tabName === activeTab;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [activeTab]);

  return (
    <div className="flex flex-col h-screen">
      <HeaderAddApp></HeaderAddApp>
      <div ref={containerRef} className="flex-1 overflow-y-auto sm:px-10 sm:py-10 px-5 py-5">
        <div
          className={`bg-[#F1EFFF] h-10 rounded relative flex flex-col justify-center overflow-x-auto ${
            applicationType?.trim().toLowerCase() === "enquiry"
              ? "bg-gray-300"
              : "bg-[#F1EFFF]"
          }`}
        >
          <div className="flex justify-center items-center h-full w-full min-w-[500px]">
            {shouldShowTab("AddNewApplication") && (
              <span
                className={`w-1/2 flex justify-center items-center cursor-pointer h-full ${
                  activeTab === "AddNewApplication"
                    ? "bg-[#4C3A68] text-[white] rounded"
                    : ""
                }`}
                onClick={() => {
                  if (applicationType !== "Enquiry") {
                    handleTabClick("AddNewApplication");
                  }
                }}
              >
                Add New Application
              </span>
            )}

            {shouldShowTab("CreateLicense") && (
              <span
                className={`w-1/2 flex justify-center items-center h-full ${
                  activeTab === "CreateLicense"
                    ? "bg-[#4C3A68] text-[white] rounded"
                    : ""
                } ${
                  applicationType?.trim().toLowerCase() === "enquiry"
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer "
                }`}
                onClick={() => {
                  if (applicationType !== "Enquiry") {
                    handleTabClick("CreateLicense");
                  }
                }}
              >
                Create Plan
              </span>
            )}
            {shouldShowTab("CreateAddOn") && (
              <span
                className={`w-1/2 flex justify-center items-center h-full  ${
                  activeTab === "CreateAddOn"
                    ? "bg-[#4C3A68] text-[white] rounded"
                    : ""
                } ${
                  applicationType?.trim().toLowerCase() === "enquiry"
                    ? "cursor-not-allowed opacity-50 "
                    : "cursor-pointer"
                }`}
                onClick={() => {
                  if (applicationType !== "Enquiry") {
                    handleTabClick("CreateAddOn");
                  }
                }}
              >
                Create Add - On
              </span>
            )}
          </div>
          {!isTabLocked && (
            <div className="sm:w-full min-w-[500px] h-1 bg-[#4C3A68] rounded-b-md absolute bottom-0"></div>
          )}
        </div>

        {activeTab === "AddNewApplication" ? (
          <AddNewApplication
            setApplicationType={setApplicationType}
            onSuccess={() => {
              setActiveTab("CreateLicense");
            }}
          />
        ) : activeTab === "CreateLicense" ? (
          <CreateLicense></CreateLicense>
        ) : activeTab === "CreateAddOn" ? (
          <CreateAddOn></CreateAddOn>
        ) : null}
      </div>
    </div>
  );
};

export default AddApplication;
